
import React from 'react';

const FileOperationOutput = ({ output }) => {
  if (!output) return null;

  // Pretty-print JSON if it's an object
  const formattedOutput =
    typeof output === 'object' ? JSON.stringify(output, null, 2) : output;

  return (
    <div >
      
      <pre className="p-2 overflow-x-auto font-mono text-sm text-gray-100 rounded-md shadow-md bg-zinc-900">
        {formattedOutput}
      </pre>
    </div>
  );
};

export default FileOperationOutput;